import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { AppComponent } from '../app.component';

@Directive({
  selector: '[appZoomableImage]'
})
export class ZoomableImageDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private appComponent: AppComponent
  ) {}

  ngOnInit(): void {
    // Add zoom cursor to indicate it's clickable
    this.renderer.setStyle(this.el.nativeElement, 'cursor', 'zoom-in');
    
    // Add a subtle transition for hover effect
    this.renderer.setStyle(this.el.nativeElement, 'transition', 'transform 0.2s');
    

    // Add a class for styling
    this.renderer.addClass(this.el.nativeElement, 'zoomable-image');
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    
  

    const img = this.el.nativeElement;

    this.appComponent.openImageModal(img.src, img.alt);
  }
  
  @HostListener('mouseenter')
  onMouseEnter(): void {
    // Subtle scale effect on hover
    this.renderer.setStyle(this.el.nativeElement, 'transform', 'scale(1.02)');
  }
  
  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.renderer.setStyle(this.el.nativeElement, 'transform', 'scale(1)');
  }
}
